'use strict';

$('.shopthelooks-container').on('click', '.dots-section_desktop, .dots-section_mobile', function () {
    var $tooltip = $(this).find('.details-container');
    $('.details-container').not($tooltip).addClass('d-none');
    $tooltip.toggleClass('d-none');
});

$(document).on('click', function (event) {
    var isClickInside = $(event.target).is('.dots-section_desktop, .dots-section_mobile, .dots-section_desktop *, .dots-section_mobile *');
    if (!isClickInside) {
        $('.details-container').addClass('d-none');
    }
});
